module.exports = __webpack_public_path__ + "img/course-title.ac3aebe1.png";